module.exports = __webpack_public_path__ + "assets/img/sea2.0ec96e15.webp";